import { instance4 } from "App/constants";
import { oneMonthBeforeToday, today } from "App/utils/helpers";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export const RESET_STATE_FORM_FILTER = {
  id:"",
  id_pembelian:"",
  supplier_id:"",
  supplier:"Pilih Supplier",
  no_faktur:"",
  tipe_pembayaran_id: "",
  kas_id: null,
  kas_name: "Pilih Kas",
  tanggal_awal: oneMonthBeforeToday(),
  tanggal_akhir: today(),
  pages: 1,
  limit: 10,
};

export const getPembayaranAll = async (formFilter, pages, limit) => {
  try {
    const api = await instance4.post(
      LIST_URL_WAREHOUSE.pembayaranLGS.get,
      {
        id:formFilter.id,
        pembelian_id:formFilter.id_pembelian,
        supplier_id:formFilter.supplier_id,
        faktur_no:formFilter.no_faktur,
        tipe_pembayaran_id: formFilter.tipe_pembayaran_id,
        kas_id: formFilter.kas_id,
        halaman: pages,
        jumlah: limit,
      }
    );

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.totalData),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error.response.data.message,
    };
  }
};
